import { useQuery } from '@tanstack/react-query';
import { identitiesApi } from '@/api';
import { identityKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';

export function useIdentities() {
  return useQuery({
    queryKey: identityKeys.list(),
    queryFn: identitiesApi.list,
    staleTime: STALE_TIMES.indefinite,
    gcTime: GC_TIMES.indefinite,
  });
}
